export default __webpack_public_path__ + "static/blob14-105ce010898a22e9111520b18c071217.svg";